(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2568],{

/***/ 733:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forum",
      function () {
        return __webpack_require__(64291);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3365,4817,4609,8441,9695,4481,5675,9162,7913,7066,7536,2777,1653,1510,4532,3792,318,541,6213,2161,6866,9774,2888,179], function() { return __webpack_exec__(733); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);